<!-- sidebar.component.html -->

<div class="sidebar-header">
  <img src="assets/images/app_logo/logo_stockfy.png" alt="Stockfy Admin" class="logo" />
</div>

<mat-nav-list>
  <a mat-list-item routerLink="/dashboard" routerLinkActive="active">📊 Dashboard</a>
  <a mat-list-item routerLink="/analytics" routerLinkActive="active">📈 Analytics</a>

  @if (isSuperAdmin) {
    <a mat-list-item routerLink="/alerts" routerLinkActive="active" class="alert-link">
      <div class="alert-item-content">
        <span>🔔 Alerts</span>
        @if (unreadAlertsCount > 0) {
          <span class="badge">{{ unreadAlertsCount }}</span>
        }
      </div>
    </a>
  }

  @if (isSuperAdmin) {
    <a mat-list-item routerLink="/audit-logs" routerLinkActive="active">📝 Audit-logs</a>
  }
  @if (isSuperAdmin) {
    <a mat-list-item routerLink="/crons" routerLinkActive="active">⏰ Cron Jobs</a>
  }
  <a mat-list-item routerLink="/invitations" routerLinkActive="active">✉️ Invitations</a>
  <a mat-list-item routerLink="/legal-content" routerLinkActive="active">📄 Legal Content</a>
  <a mat-list-item routerLink="/libraries" routerLinkActive="active">📚 Libraries</a>
  @if (isSuperAdmin) {
    <a mat-list-item routerLink="/plans" routerLinkActive="active">📦 Plans</a>
  }
  @if (isSuperAdmin) {
    <a mat-list-item routerLink="/promotions" routerLinkActive="active">🏷️ Promotions</a>
  }
  @if (isSuperAdmin) {
    <a mat-list-item routerLink="/sessions" routerLinkActive="active">🖥️ Sessions</a>
  }
  @if (isSuperAdmin) {
    <a mat-list-item routerLink="/subscriptions" routerLinkActive="active">💳 Subscriptions</a>
  }
  <a mat-list-item routerLink="/user-messages" routerLinkActive="active">📨 User Messages</a>
  <a mat-list-item routerLink="/users" routerLinkActive="active">👤 Users</a>
</mat-nav-list>